import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

type Props = {
    shown: boolean,
    onClose: () => void,
    onConfirm: () => void,
    busy: boolean,
};

export const DeleteRuleDialog: React.FC<Props> = ({
    shown,
    onClose,
    onConfirm,
    busy,
}) => (
    <Dialog
        shown={shown}
        setShown={visible => {
            if (!visible && !busy) {
                onClose();
            }
        }}>
        <DialogHeader onClose={onClose}>
            <Typography variant="heading-level-2">
                Delete Rule
            </Typography>
        </DialogHeader>
        <Group direction="v" gap="m" style={{padding: 24, width: 520}}>
            <Typography variant="heading-level-6">
                Are you sure you want to delete this Rule?
            </Typography>
            <Typography>
                This will remove the ability to approve or decline user data access requests associated with this
                rule. This action cannot be undone.
            </Typography>
        </Group>
        <DialogFooter>
            <Button
                variant="Type.SECONDARY"
                disabled={busy}
                onClick={onClose}>
                Cancel
            </Button>
            <Button
                variant="Type.PRIMARY"
                busy={busy}
                onClick={onConfirm}>
                Delete
            </Button>
        </DialogFooter>
    </Dialog>
);
